module.exports = __webpack_public_path__ + "static/media/пу.8ae8b37f.mp3";